import { memo } from 'react'

import { MessageBox, PerformanceChart, ProjectionChart } from '../../../../../components/core-v2'

type ChartsProps = {
  isErrorGeneratingPerformanceChart: boolean
  isErrorGeneratingProjectionChart: boolean
  isGeneratingPerformanceChart: boolean
  isGeneratingProjectionChart: boolean
  isMoreDataNeeded: boolean
  performanceMetrics: Record<string, number>
  projection: Record<string, number>[]
}

const ChartsInner = ({
  isErrorGeneratingPerformanceChart,
  isErrorGeneratingProjectionChart,
  isGeneratingPerformanceChart,
  isGeneratingProjectionChart,
  isMoreDataNeeded,
  performanceMetrics,
  projection
}: ChartsProps) => {
  if (isMoreDataNeeded) {
    return (
      <MessageBox title="Performance and projections">
        Complete the form to see the charts
      </MessageBox>
    )
  }

  return (
    <>
      <PerformanceChart
        isError={isErrorGeneratingPerformanceChart}
        isLoading={isGeneratingPerformanceChart}
        metrics={performanceMetrics}
        title="Historical performance"
      />
      <ProjectionChart
        isError={isErrorGeneratingProjectionChart}
        isLoading={isGeneratingProjectionChart}
        metrics={projection}
        title="Projections"
      />
    </>
  )
}

export const Charts = memo(ChartsInner)
